export default __webpack_public_path__ + "static/media/SLIDE_ESCALERAS_2.dea4f8f9.JPG";